export default __webpack_public_path__ + "c6972cc888efb93acfc9a3ea900cc711.png";